import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=178534b9&scoped=true"
import script from "./CompanyList.vue?vue&type=script&lang=js"
export * from "./CompanyList.vue?vue&type=script&lang=js"
import style0 from "./CompanyList.vue?vue&type=style&index=0&id=178534b9&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178534b9",
  null
  
)

export default component.exports